/* In-stock dots on the variant picker (Wedance, 2026-08).

   THE RULE — progressive narrowing, following the on-screen option order (Size, Heel, Colour):

     Size    dot = stock exists in this size            — any heel, any colour
     Heel    dot = stock exists in the chosen size      — with this heel, any colour
     Colour  dot = stock exists in the chosen size+heel — with this colour

   Read top to bottom, a dot means "pick this and a ready-to-ship option still exists below."

   Why this replaces Dawn's behaviour: Dawn lights a value only when THAT EXACT combination is in
   stock (`value.variant.inventory_quantity > 0`). That answers a question you can only ask once
   you've already chosen everything — and one unlucky default (a heel nobody stocks) blanked every
   dot on the page. Narrowing also never lies: the independent alternative — dot if the value has
   stock in ANY combination — would let you pick a dotted size and a dotted heel that don't exist
   together.

   Data comes from snippets/stock-dots.liquid because Liquid caps product.variants at 250 and our
   products run past that. This only ever ADDS dots; with JS off the Liquid exact-match dot stands.
   Radio pickers only — dropdown pickers keep the server-rendered behaviour. */
(function () {
  var CLASS = 'variant-in-stock';

  function readMap(scope) {
    var el = (scope || document).querySelector('script[data-stock-map]');
    if (!el) return null;
    try {
      var m = JSON.parse(el.textContent);
      if (!m || !Array.isArray(m.o) || !Array.isArray(m.r) || !m.r.length) return null;
      return m;
    } catch (e) {
      return null;
    }
  }

  /* Option groups in DOM order, keyed off data-option-name which the picker already emits —
     more reliable than parsing legend text, which carries the selected value too. */
  function groups(root) {
    var out = [];
    var byName = {};
    root.querySelectorAll('input[type="radio"][data-option-name]').forEach(function (inp) {
      var name = inp.getAttribute('data-option-name');
      if (!name) return;
      if (!byName[name]) {
        byName[name] = { name: name, inputs: [] };
        out.push(byName[name]);
      }
      byName[name].inputs.push(inp);
    });
    return out;
  }

  function labelFor(inp) {
    if (inp.id) {
      var l = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id) + '"]');
      if (l) return l;
    }
    return inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL' ? inp.nextElementSibling : null;
  }

  function apply(root) {
    var map = readMap(document);
    if (!map) return;

    /* Single-option products get NOTHING from this and must not pay its cost.
       With one option there is nothing to wildcard, so narrowing and Dawn's exact-match rule are
       identical by definition — measured store-wide, they produce the same dots on 149 of 155
       products. But the map is a snapshot, so running here would let a stale row re-add a dot that
       Liquid had correctly dropped when the last pair sold. Bailing out keeps those products on
       pure live inventory; the six multi-option products (the high-variant Aida models, where
       narrowing roughly doubles the dots) are the only ones that need it. */
    if (map.o.length < 2) return;

    var gs = groups(root);
    if (!gs.length) return;

    var col = {};
    map.o.forEach(function (n, i) {
      col[n] = i;
    });

    // current selection per option
    var chosen = {};
    gs.forEach(function (g) {
      var c = g.inputs.filter(function (i) {
        return i.checked;
      })[0];
      chosen[g.name] = c ? c.value : null;
    });

    gs.forEach(function (g, gi) {
      if (!(g.name in col)) return; // option the map doesn't know about
      var upstream = gs.slice(0, gi).filter(function (u) {
        return u.name in col && chosen[u.name] != null;
      });
      g.inputs.forEach(function (inp) {
        var hit = map.r.some(function (row) {
          if (row[col[g.name]] !== inp.value) return false;
          return upstream.every(function (u) {
            return row[col[u.name]] === chosen[u.name];
          });
        });
        var lbl = labelFor(inp);
        if (!lbl) return;
        // never strip a dot the server already rendered — JS only widens
        if (hit) lbl.classList.add(CLASS);
      });
    });
  }

  function run() {
    document.querySelectorAll('variant-selects').forEach(apply);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // the picker is replaced wholesale on variant change, so re-apply after it settles
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(run, 60);
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(run, 0);
  });
})();
